"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAssetTransaction = exports.JVMImportTransaction = exports.JVMExportTransaction = exports.JVMBaseTransaction = void 0;
const utils_1 = require("../../utils");
const constants_1 = require("../constants");
const transaction_1 = require("../transaction");
class JVMBaseTransaction extends transaction_1.BaseTransaction {
    constructor(networkId, blockchainId, outputs, inputs, memo) {
        super(constants_1.JVMBaseTransactionTypeId, networkId, blockchainId, outputs, inputs, memo);
    }
    static parse(data) {
        return transaction_1.BaseTransaction.parse(data, constants_1.JVMBaseTransactionTypeId);
    }
}
exports.JVMBaseTransaction = JVMBaseTransaction;
class JVMExportTransaction extends transaction_1.ExportTransaction {
    constructor(networkId, blockchainId, outputs, inputs, memo, destinationChain, exportedOutputs) {
        super(constants_1.JVMExportTransactionTypeId, networkId, blockchainId, outputs, inputs, memo, destinationChain, exportedOutputs);
    }
    static parse(data) {
        return transaction_1.ExportTransaction.parse(data, constants_1.JVMExportTransactionTypeId);
    }
}
exports.JVMExportTransaction = JVMExportTransaction;
class JVMImportTransaction extends transaction_1.ImportTransaction {
    constructor(networkId, blockchainId, outputs, inputs, memo, sourceChain, importedInputs) {
        super(constants_1.JVMImportTransactionTypeId, networkId, blockchainId, outputs, inputs, memo, sourceChain, importedInputs);
    }
    static parse(data) {
        return transaction_1.ImportTransaction.parse(data, constants_1.JVMImportTransactionTypeId);
    }
}
exports.JVMImportTransaction = JVMImportTransaction;
class CreateAssetTransaction extends transaction_1.BaseTransaction {
    name;
    symbol;
    denomination;
    initialStates;
    constructor(networkId, blockchainId, outputs, inputs, memo, name, symbol, denomination, initialStates) {
        super(constants_1.CreateAssetTransactionTypeId, networkId, blockchainId, outputs, inputs, memo);
        this.name = name;
        this.symbol = symbol;
        this.denomination = denomination;
        this.initialStates = initialStates;
    }
    serialize() {
        const baseTransaction = super.serialize();
        const initialStatesBytes = [];
        let initialStatesBytesSize = 0;
        for (const state of this.initialStates) {
            const bytes = state.serialize();
            initialStatesBytesSize += bytes.length;
            initialStatesBytes.push(bytes);
        }
        const buffer = utils_1.JuneoBuffer.alloc(baseTransaction.length + 2 + this.name.length + 2 + this.symbol.length + 1 + 4 + initialStatesBytesSize);
        buffer.write(baseTransaction);
        buffer.writeUInt16(this.name.length);
        buffer.writeString(this.name);
        buffer.writeUInt16(this.symbol.length);
        buffer.writeString(this.symbol);
        buffer.writeUInt8(this.denomination);
        buffer.writeUInt32(this.initialStates.length);
        for (const bytes of initialStatesBytes) {
            buffer.write(bytes);
        }
        return buffer;
    }
}
exports.CreateAssetTransaction = CreateAssetTransaction;
